export default {
    handleErrosVacina(errorData, errorForm) {
        let error = errorData.errors;

        errorForm.nomeTecnico = error.nome_tecnico ? error.nome_tecnico[0] : '';
        errorForm.nomePopular = error.nome_popular ? error.nome_popular[0] : '';
        errorForm.descricao = error.descricao ? error.descricao[0] : '';
        errorForm.contraindicacao = error.contraindicacao ? error.contraindicacao[0] : '';
        errorForm.efeitoColateral = error.efeito_colateral ? error.efeito_colateral[0] : '';
        errorForm.cuidados = error.cuidados ? error.cuidados[0] : '';
        errorForm.idTipoAplicacaoSelecionado = error.id_tipo_aplicacao ? error.id_tipo_aplicacao[0] : ''; 
        errorForm.doencasSelecionadas = error.ids_doencas ? error.ids_doencas[0] : '';
        errorForm.codeRndsVaccine = error.codigo_rnds ? error.codigo_rnds[0] : '';
        errorForm.codigoFormulario = error.codigo_formulario ? error.codigo_formulario[0] : '';
        errorForm.codigoModalidade = error.codigo_modalidade ? error.codigo_modalidade[0] : ''; 
        errorForm.codigoProjeto = error.codigo_projeto ? error.codigo_projeto[0] : '';
        errorForm.codigoSerie = error.codigo_serie ? error.codigo_serie[0] : '';
        errorForm.centroResponsabilidade = error.centro_responsabilidade ? error.centro_responsabilidade[0] : '';

        errorForm.error = '';

        this.handleErrorDoseVacina(error, errorForm);
        
        if(typeof error == 'string') {
            errorForm.error = error;
        } 
    },
    handleErrorDoseVacina(error, errorForm) {
        errorForm.dose.list = error.doses ? error.doses[0] : '';
        errorForm.dose.interval = error.intervalo_dose ? error.intervalo_dose[0] : '';
        errorForm.dose.type = error.tipo_aplicacao_dose ? error.tipo_aplicacao_dose[0] : '';
    }
}
